.searchInput {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  .searchIcon {
    display: flex;
    align-items: center;

    svg {
      path {
        stroke: var(--primitives-colors-neutral-300);
      }

      .phone &,
      .tablet & {
        width: 24px;
        height: 24px;
      }

      .activeSearch & {
        .phone &,
        .tablet & {
          width: 24px;
          height: 24px;
        }
      }
    }
  }

  .searchInputWrapper {
    background-color: var(--primitives-colors-neutral-980);
    border-radius: 16px;
    border: 1px solid rgb(255, 255, 255, 0.4);
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    transition: border-color 0.2s;
    padding: 0 16px;
    max-width: 500px;
    margin: auto;
    position: relative;
    overflow: hidden;

    .activeSearch & {
      .phone &,
      .tablet & {
        padding: 7px 16px;
        max-width: 100%;
      }
    }

    &.searchInputFocused,
    &.searchInputFilled {
      border-color: var(--primitives-colors-neutral-0);

      .searchIcon {
        path {
          stroke: var(--primitives-colors-neutral-0);
        }
      }
    }
  }

  .closeSearchButton {
    all: unset;
    width: 32px;
    height: 32px;
    cursor: pointer;
    display: none;

    .backIcon {
      width: 32px;
      height: 32px;
    }

    .activeSearch & {
      .phone &,
      .tablet & {
        display: block;
      }
    }
  }

  .resetSearchButton {
    all: unset;
    display: none;
    cursor: pointer;

    .resetIcon {
      width: 20px;
      height: 20px;

      .phone &,
      .tablet & {
        width: 24px;
        height: 24px;
      }
    }
  }

  .dynamicText {
    position: absolute;
    top: 0;
    left: 100px;
    display: flex;
    flex-direction: column;
    pointer-events: none;
    animation: move-words 10s infinite ease-in-out;

    .word {
      height: 40px;
      display: flex;
      align-items: center;
      pointer-events: none;
      color: var(--primitives-colors-neutral-0);
      font-weight: 500;
    }
  }

  .searchInputFilled {
    .dynamicText {
      display: none;
    }

    .resetSearchButton {
      display: flex;
      align-items: center;
    }
  }

  .searchInputField {
    color: var(--primitives-colors-neutral-0);
    font: var(--font-body-md-regular);
    background-color: var(--primitives-colors-neutral-980);
    padding: 7.5px 8px;
    border: none;
    width: 100%;
    border-radius: 32px;


    &::placeholder {
      color: var(--primitives-colors-neutral-300);
    }

    &:focus-visible {
      outline: none;
    }

    &:focus::placeholder {
      color: transparent;
    }

    .phone &,
    .tablet & {
      font: var(--font-body-sm-regular);
      padding: 7px 8px;
    }

    .activeSearch & {
      .phone &,
      .tablet & {
        font: var(--font-body-md-regular);
        display: block;
        padding: 4px 8px;
      }
    }
  }
}

@keyframes move-words {
  0%, 10% { transform: translateY(0%); }
  15%, 35% { transform: translateY(-20%); }
  40%, 60% { transform: translateY(-40%); }
  65%, 85% { transform: translateY(-60%); }
  90%, 100% { transform: translateY(-80%); }
}